/** An answered call belongs to the people in the room; Leave must not settle it. */
export function shouldAbandonCall(
  callId: string,
  state: { outgoingCallId: string | undefined; answeredCallId: string | undefined },
): boolean {
  return state.outgoingCallId === callId && state.answeredCallId !== callId;
}
